import { HttpRequest, HttpMethod } from "./http";

/**
 * Per-user sidebar menu preferences (show/hide + pin).
 *
 * GET  /api/v1/user/menu-prefs
 *   -> { Data: [ { hidden_menus: [...], pinned_menus: [...] } ] }
 *      (envelope `Data` is an array; the current prefs are element [0])
 * PUT  /api/v1/user/menu-prefs
 *   body: { hidden_menus: [...], pinned_menus: [...] }
 */
class MenuPrefProvider extends HttpRequest {
    Get() {
        return this.request(HttpMethod.Get, `/api/v1/user/menu-prefs`);
    }

    Update(payload) {
        return this.request(HttpMethod.Put, `/api/v1/user/menu-prefs`, payload);
    }
}

export default MenuPrefProvider;
